__turbopack_context__.v({
  "faqBox": "zIliqW_faqBox",
});
